import styled from 'styled-components'

export const BlackLink = styled.a`
  color: ${props => props.theme.textBlack};
  text-decoration: none;
  &:hover {
    color: ${props => props.theme.darkOrange};
  }
`

export const StandardLink = styled.a`
  color: ${props => props.theme.primary};
  &:visited {
    color: ${props => props.theme.primary};
  }
  &:hover {
    color: ${props => props.theme.darkOrange};
  }
  ${props => props.styles};
`

export const LinkThatLooksLikeAButton = styled.a`
  height: 4rem;
  text-decoration: none;
  display: inline-flex;
  color: ${props => props.theme.orange};
  font-family: inherit;
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
  padding: .2rem .8rem;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  white-space: nowrap;
  border-radius: 0.4rem;
  border: 0;
  background-color: ${props => props.theme.stone800};
  color: ${props => props.theme.stone50};
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 1.33333333;
  padding-block: 1.3rem;
  padding-inline: 2.2rem;
  transition: color 0.125s ease-in-out, border 0.125s ease-in-out, background 0.125s ease-in-out;
  &:hover, &:active {
      background-color: ${props => props.theme.emerald600};
      color: ${props => props.theme.stone50};
  }
  @media(min-width: ${props => props.theme.breakpoints.sm}){
    min-width: ${props => props.minWidth || '12rem'};
  }
  ${props => props.styles};
`

export const LinkThatLookLikeCTAButton = styled(LinkThatLooksLikeAButton)`
  border-radius: 0.4rem;
  background: ${props => props.theme.stone50};
  color: ${props => props.theme.stone800};
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 1.33333333;
  outline: 1px solid ${props => props.theme.stone800};
  width: fit-content;
  border: none;
  padding-block: 1.3rem;
  padding-inline: 2.2rem;
  transition: color 0.125s ease-in-out, outline 0.125s ease-in-out, background 0.125s ease-in-out;
  &:hover, &:active, &:visited {
    color: ${props => props.theme.emerald600};
    outline: 3px solid ${props => props.theme.emerald600};
    background: ${props => props.theme.stone50};
    border: none;
  }
`

export const LinkThatLooksLikeTransparentButton = styled(LinkThatLooksLikeAButton)`
  background-color: transparent;
  outline-color: ${props => props.theme.white};
  &:hover, &:active, &:visited {
    outline-color: ${props => props.theme.white};
  }
`
